import React, { Component } from "react";
import ZPartner02Header from "./ZPartner02Header";
import ZPartner02Footer from "./ZPartner02Footer";

export class ZPartner02MemberNewStep01Thx extends Component {
    static displayName = ZPartner02MemberNewStep01Thx.name;

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        const links = [
            "https://fonts.googleapis.com/css?family=Lato:300&text=1234567890,.-",
            "/css/style.css",
            "/css/style-sr.css"
        ];

        links.forEach(href => {
            const link = document.createElement("link");
            link.rel = "stylesheet";
            link.href = href;
            document.head.appendChild(link);
        });
    }    
    
    render() {                           
        return (
            <>
                <ZPartner02Header />

                <main id="main">
                    <section className="top-sr-bg bg-gray1">
                        <div className="container">
                            <div className="row justify-content-between">
                                <div className="col col-md-6">
                                    <h1 className="text-headpage text-white mb-0 pt-3 pb-3 ">
                                        <span className="d-none">Starbucks® Rewards</span>
                                        <img src="media/rewards/starbucks-rewards-logo-2.png" alt="Starbucks® Rewards" className="img-fluid" style={{ maxWidth: '158px' }} />
                                    </h1>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="section-sign-in overflow-hidden pb-5">
                        <div className="container p-1 p-md-0">                            
                            <div className="row justify-content-center px-1 px-md-5">
                                <div className="col-md-6 mb-3 pt-3">
                                    <div className="py-5 p-4 box-sign-in">
                                        <div className="row mb-4">
                                            <div className="col-1 col-md-1 p-0"><img src="media/icons/icon-preview.webp" alt="" className="img" width={40} /></div>
                                            <div className="col-11 col-md-11 p-0 ps-3">
                                                A verification email has been sent to your inbox. <br />
                                                If you haven't registered before, check your inbox for a confirmation link.
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-1 col-md-1 p-0"><img src="media/icons/icon-junk.webp" alt="" className="img" width={40} /></div>
                                            <div className="col-11 col-md-11 p-0 ps-3">
                                                เราได้ส่งอีเมลยืนยันไปยังกล่องจดหมายของคุณแล้ว  <br />
                                                หากคุณยังไม่ได้ลงทะเบียน กรุณาตรวจสอบลิงก์ยืนยันในอีเมลของคุณ
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-1 col-md-1 p-0"><img src="media/icons/LM-Icon.webp" alt="" className="img" width={40} style={{ WebkitBorderRadius: '7px', MozBorderRadius: '7px', borderRadius: '7px' }} /></div>
                                            <div className="col-11 col-md-11 p-0 ps-3">
                                                เมื่อสร้างบัญชีเรียบร้อยแล้ว ให้คลิกที่ปุ่ม กลับไปยัง LINE MAN<br />
                                                Click “Back to LINE MAN" after completing your registration.
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-1 col-md-1 p-0"><img src="media/icons/icon-check.webp" alt="" className="img" width={40} /></div>
                                            <div className="col-11 col-md-11 p-0 ps-3">
                                                บนหน้าร้านอาหารและหน้าสรุปคำสั่งซื้อจะมีเครื่องหมายถูกสีเขียวปรากฏอยู่ที่หลังคำว่า “Starbucks<sup>®</sup> Rewards”<br />
                                                Green check mark will appear after “Starbucks<sup>®</sup> Rewards” on Restaurant and Order Summary page.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>                        
                    </section>
                </main>

                <ZPartner02Footer />
            </>            
        );
    }
}
